import { __ } from "@wordpress/i18n";
import { InspectorControls } from "@wordpress/block-editor";
import { 
    PanelBody,
    TextControl,
    RangeControl,
		ToggleControl,
		SelectControl
} from "@wordpress/components";
import themes from '../../../shared/themes';
import providers from '../../../shared/providers';
import ThemePicker from '../../../components/ThemePicker';

const Inspector = ( props ) => {
	const { attributes, setAttributes } = props;
	const { lat, lng, height, zoom, themeId, themeUrl, themeAttribution, show_gpx, height_type, height_percent } = attributes;

	const setTheme = ({ id }) => {
		const themeSelected = providers.find( provider => provider.id === id);
		if( themeSelected) {
				setAttributes({
						themeId: themeSelected.id,
						themeUrl: themeSelected.url,
						themeAttribution: themeSelected.attribution,
				})
		}
}

const safeThemeUrl = (url) => {
	const reqex = /{ext}|{ex}|{e}$/;
	return url.replace(reqex, 'png');
}
	return (
			<InspectorControls>
				<PanelBody title={__('Theme', 'map-block-leaflet')} initialOpen={false}>
			 <ThemePicker
					 value={ themeId }
					 themes={ themes }
					 onChange={ setTheme }
			 />
			<label class="blocks-base-control__label" for="map-block-leaflet-text-control-xyz">{__('XYZ Tiles', 'map-block-leaflet')}</label>
		 <TextControl 
				 onChange={ themeUrl => setAttributes({ themeId: '', themeUrl: safeThemeUrl(themeUrl) })}
				 id="map-block-leaflet-text-control-xyz"
				 type="text"
				 value={themeUrl}
		 />
			<label class="blocks-base-control__label" for="map-block-leaflet-text-control-attribution">{__('Attribution', 'map-block-leaflet')}</label>
		 <TextControl 
				 onChange={ themeAttribution => setAttributes({  themeAttribution })}
				 id="map-block-leaflet-text-control-attribution"
				 type="text"
				 value={themeAttribution}
		 />
			 </PanelBody>
			<PanelBody title={__('Position')} initialOpen={false}>
					<label class="blocks-base-control__label" for="map-block-leaflet-text-control-lat">{__('Latitude')}</label>
					<TextControl 
							id="map-block-leaflet-text-control-lat"
							onChange={ lat => setAttributes({ lat: Number(lat) })}
							type="number"
							value={lat}
					/>
					<label class="blocks-base-control__label" for="map-block-leaflet-text-control-lon">{__('Longitude')}</label>
					<TextControl 
							onChange={ lng => setAttributes({lng: Number(lng)})}
							id="map-block-leaflet-text-control-lon"
							type="number"
							value={lng}
					/>
					<RangeControl
							label={__("Zoom")}
							value={zoom}
							onChange={zoom => setAttributes({ zoom: Number(zoom) })}
							min={1}
							max={17} />

			</PanelBody>
			<PanelBody title={__('Hauteur', 'map-block-leaflet')} initialOpen={false}>
			<SelectControl
						label={__("Type de mesure")}
						value={attributes.height_type}
						options={[
							{ value: '%' , label: 'Pourcentage' },
							{ value: 'vh' , label: 'Hauteur écran (vh)' },
							{ value: 'px' , label: 'Pixel' },
						]}
						onChange={(newValue) => {
							props.setAttributes({
								height_type: newValue,
							});
							props.setAttributes({
								height: 250,
							});
						}}
					/>
					{ (attributes.height_type === '%' || attributes.height_type === 'vh' ) &&
						<>
						<RangeControl
							label={__("Hauteur")}
							value={height_percent}
							onChange={height_percent => setAttributes({ height_percent: Number(height_percent) })}
							min={1}
							max={100} />
						</>
					}
					{ attributes.height_type === 'px' &&
						<>
						<label class="blocks-base-control__label" for="map-block-leaflet-text-control-lon">{__('Hauteur de la carte')}</label>
						<TextControl 
								onChange={ height => setAttributes({height: Number(height)})}
								id="map-block-leaflet-text-control-lon"
								type="number"
								step="10"
								value={height}
						/>
						</>
					}
			</PanelBody>
			<PanelBody title={__('Options', 'map-block-leaflet')} initialOpen={false}>
					<ToggleControl
								label={__("Afficher les tracés GPX")}
								checked={show_gpx}
								onChange={() => {
									setAttributes({
										show_gpx: !show_gpx,
									});
								}}
							/>
			</PanelBody>
	</InspectorControls>
	)
}

export default Inspector